import React, {memo} from 'react'
import {Handle, Position} from 'reactflow'

export default memo(({data, isConnectable}: any) => {
  return (
    <>
      <Handle
        type='target'
        position={Position.Top}
        onConnect={(params) => console.log('handle onConnect', params)}
        isConnectable={isConnectable}
        id='timeDelay1'
      />
      <div className='trigger-container'>
        <div className='trigger-box'>
          <img src='/media/svg/automation/time.svg' alt='icon' />
          <div className='trigger-data'>
            <div className='title'>Time Delay</div>
            <div className='desc'>
              Wait 30 <strong>min</strong>
            </div>
          </div>
        </div>
      </div>
      <Handle
        type='source'
        position={Position.Bottom}
        onConnect={(params) => console.log('handle onConnect', params)}
        isConnectable={isConnectable}
        id='timeDelay2'
      />
    </>
  )
})
